<h1>
    New Application
</h1>
<form #form="ngForm" (ngSubmit)="create(form)" novalidate>
    <ui-input>
        <input uiInput type="text" name="name" #nameInput [(ngModel)]="name" placeholder="Title" maxlength="40" required autocomplete="off" />
    </ui-input>
    <p>
      ID and Token will be assigned after creating the application
    </p>
    <div class="buttons">
        <button class="default">
            Create
        </button>
        <button class="outline" (click)="cancel()">
            Cancel
        </button>
    </div>
    <ui-loading *ngIf="isLoading"></ui-loading>
</form>
